import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import config from '../../../config.json';
import ArrowSvg from '../../../Assets/icons/Arrow.svg';
import 'react-alice-carousel/lib/alice-carousel.css';
import './DashboardCarousel.css';
//  SERVER_URL_IMG
const DashboardCarousel = ({ listServices }) => {
    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
    };
    const renderNextButton = ({ isDisabled }) => {
        return (
            <img
                src={ArrowSvg}
                style={{ transform: 'rotate(180deg)' }}
                className="ArrowHomepageCarousel Right"
            />
        );
    };

    const renderPrevButton = ({ isDisabled }) => {
        return <img src={ArrowSvg} className="ArrowHomepageCarousel Left" />;
    };

    const itemsArr = [
        {
            id: 1,
            imageUrl: `${config.SERVER_URL_IMG}media/images/dashboard/Framework_Cover.jpg`,
            title: 'OOLA LIFESTYLE FRAMEWORK',
            content: `The Oola Lifestyle Framework, our signature program, helps
people transform their lives for the better. By combining our
powerful customized e-learning platform, accountability app, and
community, you can find a life of balance, growth, and purpose.`,
            urlProduct:
                ' https://myoola.oolalife.com/corporphan/enrollment/enrollmentmember',
        },
        {
            id: 2,
            imageUrl: `${config.SERVER_URL_IMG}media/images/dashboard/Miracle_Mindset_course.jpg`,
            title: 'MIRACLE MINDSET',
            content: `In just 21 days, you will learn how to stop blocking miracles 
                        and how to experience daily miracles instead. These simple, yet 
                        effective and powerful, shifts will open you up to an abundance
                        of joy, inner peace and success in all areas of your life.`,
            urlProduct:
                ' https://myoola.oolalife.com/corporphan/enrollment/enrollmentmember',
        },
        {
            id: 3,
            imageUrl: `${config.SERVER_URL_IMG}media/images/dashboard/Body_By_Design.jpg`,
            title: 'OOLA BODY BY DESIGN',
            content: `Imagine feeling lean, strong, self-confident and healthy without
            ever dieting again! This 7-week positive weight management
            course led by Coach Krystal Nielson is a fully customized
            step-by-step macro based program to get you fast and lasting
            fitness results.`,
            urlProduct:
                ' https://myoola.oolalife.com/corporphan/enrollment/enrollmentmember',
        },
        {
            id: 4,
            imageUrl: `${config.SERVER_URL_IMG}media/images/dashboard/Green_Gap_course.jpg`,
            title: 'OOLA GREEN GAP',
            content: `Imagine a life free of financial stress. Our signature
            financial wellness course will teach you a proven system
            to help you pay off debt,invest in your future, all
            while having some fun along the way.`,
            urlProduct:
                ' https://myoola.oolalife.com/corporphan/enrollment/enrollmentmember',
        },
    ];
    const handSvg = () => (
        <svg
            width={'50'}
            height={'50'}
            viewBox={'0 0 725 755'}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="handSVG"
        >
            <g clipPath="url(#clip0)" transform="scale(5) translate(-220 -260)">
                <path
                    d="M345.397 379.36L348.717 355.016C349.126 350.437 345.723 346.891 341.088 347.122C339.619 347.195 338.206 347.643 336.948 348.379C336.772 344.341 333.548 341.371 329.295 341.583C327.829 341.659 326.416 342.107 325.156 342.834C324.973 338.803 321.752 335.829 317.502 336.044C316.064 336.116 314.681 336.546 313.441 337.249L314.416 326.342C314.826 321.763 311.422 318.217 306.788 318.448C302.193 318.674 298.12 322.591 297.71 327.176L293.964 369.077L280.484 359.321C276.893 356.635 271.394 357.292 267.686 360.857C264.907 363.529 264.537 367.671 266.861 370.089L293.362 397.653C297.491 401.948 303.295 404.137 309.707 403.817L319.415 403.333C325.818 403.016 332.061 400.226 336.991 395.486C341.596 391.059 344.581 385.331 345.397 379.36ZM319.804 398.981L310.096 399.465C304.851 399.727 300.102 397.936 296.723 394.422L270.222 366.857C269.446 366.05 269.569 364.672 270.497 363.78C272.541 361.815 275.574 361.452 277.578 362.952L294.322 375.066C294.942 375.516 295.813 375.54 296.58 375.134C297.341 374.729 297.871 373.955 297.944 373.136L302.073 326.958C302.269 324.773 304.211 322.906 306.436 322.791C307.531 322.74 308.486 323.133 309.14 323.815C309.795 324.496 310.151 325.465 310.053 326.56L307.3 357.352C307.193 358.552 308.084 359.479 309.287 359.419C309.889 359.386 310.457 359.115 310.887 358.702C311.318 358.288 311.61 357.731 311.664 357.128L312.788 344.554C312.984 342.369 314.923 340.505 317.151 340.394C319.335 340.285 320.963 341.977 320.768 344.156L319.643 356.736C319.536 357.936 320.427 358.863 321.63 358.803C322.232 358.77 322.8 358.5 323.231 358.086C323.661 357.672 323.953 357.116 324.007 356.512L324.581 350.093C324.776 347.908 326.716 346.044 328.944 345.933C331.128 345.824 332.756 347.516 332.561 349.695L331.984 356.145C331.987 356.154 331.984 356.151 331.984 356.151L331.983 356.157C331.983 356.163 331.983 356.163 331.983 356.163C331.982 356.169 331.982 356.169 331.982 356.169L331.985 356.172C331.988 356.175 331.984 356.178 331.984 356.178C331.91 357.352 332.795 358.246 333.977 358.183C335.18 358.123 336.246 357.099 336.353 355.899L336.377 355.634C336.471 354.576 336.974 353.558 337.791 352.773C338.607 351.988 339.638 351.526 340.736 351.471C342.927 351.368 344.542 353.055 344.366 355.132L341.059 379.374C340.389 384.254 337.948 388.94 334.181 392.563C330.147 396.44 325.044 398.72 319.804 398.981Z"
                    fill="#344A58"
                />
                <path
                    d="M323.781 332.78C327.149 325.447 326.132 317.379 321.185 312.233C314.212 304.98 301.752 305.602 293.413 313.619C287.498 319.306 285.023 327.548 287.1 334.613C287.188 334.906 287.337 335.156 287.531 335.358C288.065 335.913 288.947 336.09 289.801 335.741C290.966 335.257 291.646 333.973 291.324 332.871C289.705 327.373 291.626 320.963 296.224 316.542C302.711 310.306 312.4 309.823 317.825 315.465C321.67 319.464 322.457 325.739 319.836 331.448C319.307 332.593 319.762 333.826 320.854 334.188C321.945 334.557 323.255 333.928 323.781 332.78Z"
                    fill="#344A58"
                />
            </g>
        </svg>
    );
    const items = listServices.map((item, i) => (
        <div
            key={`${item.id}HomePageOolaCarousel__ImageItem`}
            data-value={i}
            className="HomePageOolaCarousel__ImageItem Item "
        >
            <img
                alt="OolaShot"
                src={`${item.imageUrl.replace(
                    '${config.SERVER_URL_IMG}',
                    config.SERVER_URL_IMG
                )}`}
            />
            <div className="filterBuyCard">
                <button
                    className="button-full-mid HomePageOolaCarousel__btnGetTickets"
                    onClick={() => window.open(item.urlProduct, '_blank')}
                >
                    {item.productTypeId == 1 ? 'LEARN MORE' : 'SHOP NOW'}
                </button>
            </div>
            {/* <article className="handSVG__container">{handSvg()}</article> */}
            <h1>{item.title}</h1>
            <p>{item.content}</p>
        </div>
    ));

    return (
        <div className="HomePageOolaCarousel__Container">
            <AliceCarousel
                mouseTracking
                items={items}
                responsive={responsive}
                controlsStrategy="alternate"
                // autoPlay
                infinite
                autoPlayInterval={3000}
                animationDuration={1000}
                renderPrevButton={renderPrevButton}
                renderNextButton={renderNextButton}
            />
        </div>
    );
};

export default DashboardCarousel;
